import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    iconfont: 'mdi'
}

export default new Vuetify(opts)


// WEBPACK FOOTER //
// ./src/plugins/Vuetify.js